import type { SuperBoostRuleSet } from "./types.js";

// super-boost ruleset for FY2026-27 (1 July 2026 – 30 June 2027).
//
// Reprices from fy2025-26: the general concessional cap indexes to $32,500
// (AWOTE, 1 Jul 2026, CITED — carry-forward ledger #2, cap-expiry ledger #5),
// and the general transfer balance cap used as the TSB ceiling indexes to
// $2.1m (CITED — co-contribution/spouse ledger #6).
//
// Held from 2025-26 (no change yet legislated for this FY): the co-contribution
// $500 max / 50% match / 3.333c taper and its lower/higher thresholds, the
// spouse-offset $540 mechanic ($3,000 base, $37,000/$40,000), the 15% in-fund
// rate, the $500k carry-forward TSB gate (unindexed), and LISTO ($500 / $37,000
// — the rise to $45,000/$810 takes effect 1 Jul 2027, a later FY).
//
// NOTE: the co-contribution lower/higher income thresholds index annually; the
// 2026-27 ATO figures should be re-verified at the FY rollover and corrected
// here if they move (they are carried at the 2025-26 values pending that
// verification — flagged in the build return as a documented assumption).
export const fy2026_27: SuperBoostRuleSet = {
  engine: "super-boost",
  fy: "2026-27",
  effectiveFrom: "2026-07-01",
  effectiveTo: "2027-06-30",
  sources: {
    coContribution:
      "https://www.ato.gov.au/individuals-and-families/super-for-individuals-and-families/super/growing-and-keeping-track-of-your-super/how-to-save-more-in-your-super/government-super-contributions/super-co-contribution",
    coContributionRates:
      "https://www.ato.gov.au/tax-rates-and-codes/key-superannuation-rates-and-thresholds/government-contributions",
    spouseOffset:
      "https://www.ato.gov.au/individuals-and-families/super-for-individuals-and-families/super/growing-and-keeping-track-of-your-super/how-to-save-more-in-your-super/spouse-super-contributions",
    concessionalCap:
      "https://www.ato.gov.au/tax-rates-and-codes/key-superannuation-rates-and-thresholds/contributions-caps",
    carryForward:
      "https://www.ato.gov.au/individuals-and-families/super-for-individuals-and-families/super/growing-and-keeping-track-of-your-super/caps-limits-and-tax-on-super-contributions/concessional-contributions-cap",
    transferBalanceCap:
      "https://www.ato.gov.au/tax-rates-and-codes/key-superannuation-rates-and-thresholds/transfer-balance-cap",
    listo:
      "https://www.ato.gov.au/individuals-and-families/super-for-individuals-and-families/super/growing-and-keeping-track-of-your-super/how-to-save-more-in-your-super/government-super-contributions/low-income-super-tax-offset",
  },
  sourcesVerifiedAt: "2026-06-22",

  coContribution: {
    maxAmount: 500,
    matchingRate: 0.5,
    lowerThreshold: 47_488,
    higherThreshold: 62_488,
    taperRate: 0.03333,
    maxAgeExclusive: 71,
    tsbCap: 2_100_000, // general transfer balance cap indexes to $2.1m for 2026-27
  },

  spouseOffset: {
    offsetRate: 0.18,
    maxContributionBase: 3_000,
    fullOffsetThreshold: 37_000,
    cutOutThreshold: 40_000,
    tsbCap: 2_100_000,
  },

  concessionalCap: 32_500, // AWOTE indexation, 1 Jul 2026
  concessionalTaxRate: 0.15,

  carryForward: {
    windowYears: 5,
    firstAccrualFy: "2018-19",
    tsbGate: 500_000, // unindexed
  },

  listo: {
    max: 500,
    incomeThreshold: 37_000,
    rate: 0.15,
  },
};
